import { NavLink } from 'react-router-dom';
import s from '../styles/modules/Header.module.scss';
import logo from '../assets/img/logo.png';
import { LogOut, User } from 'lucide-react';
import { Button } from './ui/button';
import LogoutDialog from './LogoutDialog';
import { useHeader } from '../hooks/useHeader';
import { HeaderProps } from '../@types/props.types';
import { Card } from './ui/card';
import HeaderProfileBlock from './HeaderProfileBlock';

const Header = ({ menuTrigger }: HeaderProps) => {
  const { logoutDialogOpen, handleLogout, setLogoutDialogOpen, userName } = useHeader();

  return (
    <>
      <div className="fixed left-0 right-0 top-0 z-50 border-b bg-white shadow-sm">
        <div className="mx-auto max-w-[1080px]">
          <div className={s.wrapper}>
            <NavLink to={'/home'} className="flex-1">
              <div className={s.logo_wrapper}>
                <img className={s.logo} src={logo} alt="" />
                <span className={s.logo_text}>АкваCтар</span>
              </div>
            </NavLink>

            <div className={s.profile_wrapper}>
              <HeaderProfileBlock />
              <div className="hidden items-center gap-4 md:flex">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setLogoutDialogOpen(true)}
                  className="border border-red-100 text-red-500 hover:bg-red-100 bg-red-50 hover:text-red-600">
                  <LogOut className="mr-2 h-4 w-4" />
                  Выйти
                </Button>
              </div>
              <div className="md:hidden">{menuTrigger}</div>
            </div>
          </div>
        </div>
      </div>

      <LogoutDialog
        isOpen={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={() => {
          handleLogout();
          setLogoutDialogOpen(false);
        }}
      />
    </>
  );
};

export default Header;
